export const KYC_DATA_AUTOMATION_VARIABLES = ['PAN', 'GST_FILING', 'BANK','VEHICLE_NUMBER','EMAIL', 'CHALLAN','FSSAI_CERTIFICATE', 'TAN', 'KYB'];